// extracted by mini-css-extract-plugin
module.exports = {"TabNavigation":"TabNavigation--e5sEB","BetaTag":"BetaTag--28zWo"};